(function () {
    'use strict';

    angular.module("imApp").factory("requisitionCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 760,
                    parameters: parms || {}
                });
            },
            createRequisition: function (edit) {
                return $ihttp.post({
                    method: 761,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
